import { Box } from "@material-ui/core";
import { CSSProperties } from "react";

interface RxBoxProps {
	label?: string;
	color?: string;
	style?: CSSProperties;
	className?: string;
}

const RxBox = (props: RxBoxProps) => {
	return (
		<Box color={props.color} style={props.style} className={props.className}>
			{props.label}
		</Box>
	);
};

export default RxBox;
